export default __webpack_public_path__ + "static/media/my-cart.59a961e2.svg";